import designerReport from '@/reporter/instance/designerReport';
export const AI_MODULE_MAP = {
    LESSCODE: 'wuji:lesscode',
    LESSCODE_MODULE: 'wuji:lesscode:module',
    UICORE_CODE: 'wuji:uicoreai',
    ROUTE_GUARD: 'wuji:route:guard',
    DATASOURCE_METHOD: 'wuji:datasource:method',
    DATASOURCE_PLUGIN: 'wuji:datasource:plugin',
    DATASOURCE_NODEJS: 'wuji:datasource:nodejs',
    DATASOURCE_MCP: 'wuji:datasource:mcp',
    PARSE_API_DOC: 'wuji:parse:apidoc',
    PUBLISH_VERSION_DESC: 'wuji:publish:version:desc',
    CHAT: 'chat',
    BI: 'wuji:bi',
    LAYOUT: 'wuji:layout',
    ATOM_MANAGER: 'AtomManager',
    FLOW_ENGINE: 'wuji:flowEngine',
    RUNTIME_AI_ATOM: 'wuji:runtime:ai:atom',
    RUNTIME_AI_SDK: 'wuji:runtime:ai:sdk',
    AIPAGE_GENERATOR: 'wuji:aipage:generator',
};
// i18n ignore next line
const eid = 'ai消息发送(全)';
const mod = 'ai';
const traceIdWithoutModule = Date.now().toString(36);
export const getTraceIdWithoutModule = () => traceIdWithoutModule;
const getTraceId = (id) => `${id} || ${traceIdWithoutModule}`;
let traceSeq = 0;
/** 每次调用生成新的 traceId。后缀带递增序号，避免同一毫秒内撞车。 */
export function createTraceId(id) {
    traceSeq += 1;
    return `${id} || ${Date.now().toString(36)}-${traceSeq.toString(36)}`;
}
/**
 * 返回带上本次 traceId 的请求头。
 * 已有 x-wuji-trace-id 时原样返回：SDK 重试会再次进入这里，同一次调用要保持同一个 traceId。
 */
export function withRequestTraceId(headers, id) {
    if (headers?.['x-wuji-trace-id'])
        return headers;
    return {
        ...headers,
        'x-wuji-trace-id': createTraceId(id),
    };
}
export const getTraceIdHeaders = (id) => ({
    'x-wuji-trace-id': getTraceId(id),
});
export const reportDesignerAISendMessage = ({ d1, d2 }) => {
    designerReport.report('click', { eid, mod, d1, d2 });
};
